<header-title [model]="headerTitle"></header-title>

    <section class="card">
        <header class="card-header">
            <h3 *ngIf="headerTitle" class="text-gray-600 m-0"><i class="fas fa-cubes me-2"></i>Create New Module</h3>
        </header>
        <div class="card-body py-5">
            <div class="container">
                <form (submit)="addModule()" [formGroup]="addModuleFormGroup">
                    <fieldset>
                        <div class="panel-body">
                            <error-message [errors]="errors"></error-message>
                            <div class="row mt-3">
                                <div class="col-md-6">
                                    <label class="control-label">Name</label>
                                    <input type="text" class="form-control" formControlName="name" />
                                </div>

                                <div class="col-md-3">
                                    <label class="control-label">
                                        Is Active
                                    </label>
                                    <input type="checkbox" id="isActive" name="isActive" class="form-control" formControlName="isActive" appToggle />
                                </div>
                            </div>
                        </div>
                        <footer class="panel-footer mt-3">
                            <div class="row">
                                <div class="col text-end">
                                    <button class="btn btn-outline-primary ms-2" type="button" (click)="onBack()">Back</button>
                                    <button class="btn btn-success ms-2" type="submit">Create</button>
                                </div>
                            </div>
                        </footer>
                    </fieldset>
                </form>
            </div>
        </div>
</section>

